// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  gateId: __t.u64().primaryKey().name("gate_id"),
  workspaceId: __t.u64().name("workspace_id"),
  agendaId: __t.u64().name("agenda_id"),
  expectedOutputsJson: __t.string().name("expected_outputs_json"),
  actualEvidenceRefsJson: __t.string().name("actual_evidence_refs_json"),
  severity: __t.string(),
  status: __t.string(),
  openedAt: __t.i64().name("opened_at"),
  closedAt: __t.i64().name("closed_at"),
  reviewerKind: __t.string().name("reviewer_kind"),
  reviewerAgentId: __t.u64().name("reviewer_agent_id"),
});
